import { render, staticRenderFns } from "./FormPercepcionCargasFamilia.vue?vue&type=template&id=2757bd3c&scoped=true&"
import script from "./FormPercepcionCargasFamilia.vue?vue&type=script&lang=js&"
export * from "./FormPercepcionCargasFamilia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2757bd3c",
  null
  
)

export default component.exports